import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})



export class DraftManagerService {

  /** @var {BehaviorSubject} Source of all picks and bans */
  private draftSource = new BehaviorSubject<{}>({ });
  /** @var An object containing all picked and banned champions by players */
  public draft = this.draftSource.asObservable();
  public draftType = "free";
  /** @var Phase of the draft */
  public phase = {type: null, id: null, name: "Free Draft", component: null};
  private phaseSource = new BehaviorSubject<{}>({ });
  public phaseObservable = this.phaseSource.asObservable();
  public phaseNum = -1;
  public phaseList = [
    {type: "bans", id: "B1", name: "Blue Ban 1", component: null},
    {type: "bans", id: "R1", name: "Red Ban 1", component: null},
    {type: "bans", id: "B2", name: "Blue Ban 2", component: null},
    {type: "bans", id: "R2", name: "Red Ban 2", component: null},
    {type: "bans", id: "B3", name: "Blue Ban 3", component: null},
    {type: "bans", id: "R3", name: "Red Ban 3", component: null},
    {type: "picks", id: "B1", name: "Blue Pick 1", component: null},
    {type: "picks", id: "R1", name: "Red Pick 1", component: null},
    {type: "picks", id: "R2", name: "Red Pick 2", component: null},
    {type: "picks", id: "B2", name: "Blue Pick 2", component: null},
    {type: "picks", id: "B3", name: "Blue Pick 3", component: null},
    {type: "picks", id: "R3", name: "Red Pick 3", component: null},
    {type: "bans", id: "R4", name: "Red Ban 4", component: null},
    {type: "bans", id: "B4", name: "Blue Ban 4", component: null},
    {type: "bans", id: "R5", name: "Red Ban 5", component: null},
    {type: "bans", id: "B5", name: "Blue Ban 5", component: null},
    {type: "picks", id: "R4", name: "Red Pick 4", component: null},
    {type: "picks", id: "B4", name: "Blue Pick 4", component: null},
    {type: "picks", id: "B5", name: "Blue Pick 5", component: null},
    {type: "picks", id: "R5", name: "Red Pick 5", component: null},
    {type: "end", id: "null", name: "End of Draft", component: null},
  ];
  public draftTimerComponent: any = undefined;



  constructor() {
    // Set all drafts to null upon service instantiation
    this.reset();
  }



  /**
   * Set all drafts to null
   */
  public reset() {
    this.draftSource.next({
      picks: {
        B1: null, B2: null, B3: null, B4: null, B5: null,
        R1: null, R2: null, R3: null, R4: null, R5: null,
      },
      bans: {
        B1: null, B2: null, B3: null, B4: null, B5: null,
        R1: null, R2: null, R3: null, R4: null, R5: null,
      }
    })
    if (this.draftTimerComponent !== undefined) {
      this.draftTimerComponent.resetTimer();
      this.draftTimerComponent.endTimer();
    }
  }

  public refresh() {
    this.draftSource.next(this.draftSource["_value"]);
  }

  

  /**
   * Draft a champion.
   * @param {string} type "picks" or "bans"
   * @param {string} player The ID of the player that is drafting
   * @param {string} champion The ID of the champion that is being drafted
   */
  public setDraft(type: string, player: string, champion: string) {
    this.draftSource["_value"][type][player] = champion;
    this.draftSource.next(this.draftSource["_value"]);
  }

  public setDraftType(type: string) {
    this.draftType = type;
    this.draftTimerComponent.draftType = type;
    if (type === "free") {
      this.draftTimerComponent.pause = true;
    }
    else {
      this.draftTimerComponent.pause = false;
    }
  }

  public nextPhase() {
    this.phaseNum++;
    this.phase = this.phaseList[this.phaseNum];
    this.phaseSource.next(this.phase);
    this.draftTimerComponent.descText = this.phase['name'];
    this.draftTimerComponent.phase = this.phase;
  }

  public setComponent(type: string, id: string, component: any) {
    for (let i = 0; i < this.phaseList.length; i++) {
      if (this.phaseList[i].id === id && this.phaseList[i].type === type)
        this.phaseList[i].component = component;
    }
  }



}